import type { ValidationError } from "@repo/core";

const EMAIL_ALREADY_TAKEN = "EmailAlreadyTaken";
const EMAIL_INVALID = "EmailInvalid";
const PHONE_NUMBER_NOT_VALID = "PhoneNumberNotValid";
const BIRTH_DATE_NOT_APPLICABLE = "BirthDateNotApplicable";
const BIRTH_DATE_INVALID = "BirthDateInvalid";
const COUNTRY_CODE_INVALID = "CountryCodeInvalid";
const LOCALE_INVALID = "LocaleInvalid";
const BRAND_INVALID = "BrandInvalid";
const MISSING_FIELD_VALUE = "MissingFieldValue";
const PASSWORD_TOO_SHORT = "PasswordTooShort";
const PASSWORD_NOT_VALID = "PasswordNotValid";
const COMPANY_NAME_INVALID = "CompanyNameInvalid";
const COMPANY_ORGANIZATIONAL_NUMBER_INVALID =
  "CompanyOrganizationalNumberInvalid";

export function mapValidationError<T = unknown>({
  validationError,
  validationErrorDetails,
}: ValidationError): [T, string] | undefined {
  if (validationError === MISSING_FIELD_VALUE) {
    if (typeof validationErrorDetails === "string") {
      return [validationErrorDetails as T, "errorMissingFieldValue"];
    }
    return undefined;
  }
  if (validationError === EMAIL_ALREADY_TAKEN) {
    return ["email" as T, "errorEmailAlreadyTaken"];
  }
  if (validationError === EMAIL_INVALID) {
    return ["email" as T, "errorEmailInvalid"];
  }
  if (validationError === PHONE_NUMBER_NOT_VALID) {
    return ["phoneNumber" as T, "errorPhoneNumberNotValid"];
  }
  if (validationError === BIRTH_DATE_NOT_APPLICABLE) {
    return ["birthDate" as T, "errorBirthDateNotApplicable"];
  }
  if (validationError === BIRTH_DATE_INVALID) {
    return ["birthDate" as T, "errorBirthDateInvalid"];
  }
  if (validationError === COUNTRY_CODE_INVALID) {
    return ["countryCode" as T, "errorCountryCodeInvalid"];
  }
  if (validationError === LOCALE_INVALID) {
    return ["locale" as T, "errorLocaleInvalid"];
  }
  if (validationError === BRAND_INVALID) {
    return ["brand" as T, "errorBrandInvalid"];
  }
  if (validationError === PASSWORD_TOO_SHORT) {
    return ["password" as T, "errorPasswordTooShort"];
  }
  if (validationError === PASSWORD_NOT_VALID) {
    return ["password" as T, "errorPasswordNotValid"];
  }
  if (validationError === COMPANY_NAME_INVALID) {
    return ["companyName" as T, "errorMissingFieldValue"];
  }
  if (validationError === COMPANY_ORGANIZATIONAL_NUMBER_INVALID) {
    return ["companyOrganizationalNumber" as T, "errorMissingFieldValue"];
  }
  return undefined;
}
